module.exports = __webpack_public_path__ + "img/menu-background.33f99cbd.jpg";